import FeatherIcon from "feather-icons-react";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button, Stack } from "@components/base";
import { useMultistepFormStore } from "@components/common/MultistepForm";
import { useUserStore } from "@store/user";
import { useUpdateFormSectionConfig } from "@api";

const EditSectionButtons: FC = () => {
  const { t } = useTranslation();
  const {
    activeSection,
    formSettings: {
      editMode,
      formBasics: { id },
    },
    setEditSectionOpen,
    setDeleteSectionOpen,
  } = useMultistepFormStore();
  const { user } = useUserStore();
  const { updateFormSectionConfigEnabled } = useUpdateFormSectionConfig(user, id);

  return (
    updateFormSectionConfigEnabled &&
    activeSection &&
    editMode && (
      <Stack direction="row" spacing={1}>
        <Button
          variant="text"
          size="extraSmall"
          startIcon={<FeatherIcon icon="edit" />}
          onClick={() => setEditSectionOpen(true)}
        >
          {t("multistep.editSection")}
        </Button>
        <Button
          variant="text"
          size="extraSmall"
          startIcon={<FeatherIcon icon="trash-2" />}
          onClick={() => setDeleteSectionOpen(true)}
          color="error"
        >
          {t("multistep.deleteSection")}
        </Button>
      </Stack>
    )
  );
};

export default EditSectionButtons;
